import { useCallback, useState } from 'react';
// TODO: Replace with real implementation when API is ready
export function useSendRevokeNotificationEmail() {
  const [loading, setLoading] = useState(false);

  // eslint-disable-next-line @typescript-eslint/no-unused-vars
  const sendEmail = useCallback(async (_examCenterCode: string) => {
    setLoading(true);
    await new Promise((resolve) => setTimeout(resolve, 1000));
    setLoading(false);
  }, []);

  return [sendEmail, { loading }] as const;
}
